module.exports = __webpack_public_path__ + "img/BONITA.1786f309.png";